import { observer } from 'mobx-react';
import _ from 'lodash';
import { useStore } from 'app/context';
import { useLocation } from 'react-router';
import 'echarts-extension-gmap';
import { Icon } from 'app/components/common/Icon';
import routes from 'routes';
import React from 'react';

interface IMapInfo {
	vmInfoComponent?: React.ReactElement<{ agtId: number }>;
}

export interface IMapInfoAgtDetailElement {
	agtId: number;
}

export const MapInfo = observer((props: IMapInfo) => {
	const { agenturMapsUiStore } = useStore();
	const location = useLocation();

	const getUrl = (agtId: number) => {
		return '#' + routes.AGENTUR.getPath(agtId.toString()) + location.search;
	};

	if (agenturMapsUiStore.activeAgts.length === 0) {
		return null;
	}

	return (
		<div id="infowindowcontent" className="infowindowcontent" style={{ position: 'relative', zIndex: 222000 }}>
			{agenturMapsUiStore.activeAgts.length > 0 && (
				<>
					<div className="maps-agt-group">
						{agenturMapsUiStore.activeAgts.length > 1 ? <span className="title is-5">Agenturen an diesem Standort</span> : <span className="title is-5">Agentur</span>}
						{agenturMapsUiStore.activeAgts!.map((agt) => {
							const idx = agenturMapsUiStore.currentLegend.getIndex(agt);
							const color = agenturMapsUiStore.currentLegend.getColorByIndex(idx);

							return (
								<div className="maps-agt-group-item" key={`map-${agt.agtId}`}>
									{color && (
										<span style={{ color: color }}>
											<Icon iconClass="circle" />{' '}
										</span>
									)}
									<a className="button is-text" href={getUrl(agt.agtId)}>
										{agt.name} ({agt.agtId})
									</a>
									{props.vmInfoComponent && <>{React.cloneElement(props.vmInfoComponent, { agtId: agt.agtId })}</>}
								</div>
							);
						})}
					</div>
				</>
			)}
		</div>
	);
});
